import { saveAs } from "file-saver";
import { AllocationKey, UnitOfArea, postDatapointsExcel } from "api/ux/src";
import { language } from "language/default";
export const withOptions = (queryConfig) => {
    queryConfig.force = true;
    queryConfig.options = queryConfig.options || {};
    if (queryConfig.options.headers) {
        queryConfig.options.headers.requestBlob = "true";
    }
    queryConfig.meta = {
        ...{
            errorMessage: language.en.grid.excelExport.downloadExcelFailed,
            pendingMessage: language.en.grid.excelExport.downloadExcelPending,
            successMessage: language.en.grid.excelExport.downloadExcelSucceeded
        }
    };
    return queryConfig;
};
export const exportFunds = (request, currentTab) => {
    const data = request?.datapointsExcelRequest;
    const requestParameters = {
        datapointsExcelRequest: {
            allocationKey: data?.allocationKey ?? AllocationKey.Nav,
            asOfDate: new Date(),
            commitmentCalculation: data?.commitmentCalculation,
            dashboardOptions: { excelExcludeSummary: true },
            entityId: data?.entityId,
            entityType: data?.entityType,
            id: data?.id,
            requests: data?.requests,
            selectedCurrency: data?.selectedCurrency ?? "USD",
            unitOfArea: data?.unitOfArea ?? UnitOfArea.SquareMeter
        }
    };
    const requestConfig = postDatapointsExcel(requestParameters, {
        queryKey: "ExportFunds",
        transform: (body) => {
            if (body?.size > 0) {
                saveAs(body, `InsightExport_${currentTab}.xlsx`);
            }
            return {};
        }
    });
    withOptions(requestConfig);
    return requestConfig;
};
